module.exports = __webpack_public_path__ + "img/faktaq.36e3e7a4.png";